import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TableColumn } from 'src/app/components/table';
import { ShopProductStockEntryService } from 'src/app/connect-api/api/shop/shop-product-stock-entry.service';

@Component({
  selector: 'app-product-stock-entries',
  templateUrl: './product-stock-entries.component.html',
  styleUrl: './product-stock-entries.component.scss'
})
export class ProductStockEntriesComponent implements OnInit {
  private title = inject(Title);
  protected stockEntryService = inject(ShopProductStockEntryService);

  cols: TableColumn[];

  ngOnInit() {
    this.title.setTitle('Loja - Histórico Produtos Nota');
    this.cols = this.columns;
  }

  get columns() {
    return [
      new TableColumn.Builder()
        .setHeader('ID')
        .setField('id')
        .setCondition('equals')
        .build(),
      new TableColumn.Builder()
        .setHeader('SKU')
        .setField('codProduct')
        .setRouterLink('/shop-products/catalog/product/')
        .setRouterLinkFieldName('productId')
        .setCondition('equals')
        .build(),
      new TableColumn.Builder()
        .setHeader('Nota')
        .setField('invoiceId')
        .setCondition('equals')
        .build(),
      new TableColumn.Builder()
        .setHeader('Descrição Produto')
        .setField('productDescription')
        .setCondition('contains')
        .build(),
      new TableColumn.Builder()
        .setHeader('Descrição Evento')
        .setField('eventDescription')
        .setCondition('contains')
        .build(),
      new TableColumn.Builder()
        .setHeader('Valor NF')
        .setField('invoiceValue')
        .setType('currency')
        .build(),
      new TableColumn.Builder()
        .setHeader('Preço')
        .setField('price')
        .setType('currency')
        .build(),
      new TableColumn.Builder()
        .setHeader('Quantidade')
        .setField('quantity')
        .setType('formattedInteger')
        .build(),
      new TableColumn.Builder()
        .setHeader('Chave NFe')
        .setField('nfeKey')
        .setCondition('contains')
        .build(),
      new TableColumn.Builder()
        .setHeader('Lote')
        .setField('batch')
        .setCondition('contains')
        .build(),
      new TableColumn.Builder()
        .setHeader('Data Criação')
        .setField('createdAt')
        .setType('date')
        .setCondition('between')
        .build()
    ];
  }
}
